import type { Ref } from 'react';
import { NumberStepper } from './NumberStepper';

export interface WeightInputProps {
  /** Weight in grams (`null` when empty). */
  value: number | null;
  onChange: (grams: number | null) => void;
  /** Step of the buttons in kg (default 0.5). */
  stepKg?: number;
  /** Largest value in grams. */
  max?: number;
  labels: { decrement: string; increment: string };
  /** Unit shown after the number (default `kg`). */
  unit?: string;
  locale?: string;
  id?: string;
  invalid?: boolean;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  'aria-describedby'?: string;
  'aria-label'?: string;
  size?: 'sm' | 'md' | 'lg';
  ref?: Ref<HTMLInputElement>;
}

/**
 * Weight entry in kg with gram precision. The value is kept in grams, so
 * sums stay exact (no floating point kilograms in the state).
 */
export function WeightInput({
  value,
  onChange,
  stepKg = 0.5,
  max,
  unit = 'kg',
  ...rest
}: WeightInputProps) {
  return (
    <NumberStepper
      {...rest}
      value={value === null ? null : value / 1000}
      onChange={(kg) => onChange(kg === null ? null : Math.round(kg * 1000))}
      min={0}
      {...(max !== undefined ? { max: max / 1000 } : {})}
      step={stepKg}
      decimals={3}
      unit={unit}
    />
  );
}
